import { Component, OnInit, Injector, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// components
import { DxPopupComponent } from 'devextreme-angular';
import { ItemDetailsComponent } from '../../../shared/components/item-details/item-details.component';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

// models
import { DistributionNumber } from '../../../shared/models/distribution-number';

// services
import { DistributionManagementService } from '../../shared/services/distribution-management.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { TranslateService } from '@ngx-translate/core';
import { AuctionClusterBuyerService } from '../../shared/services/auction-cluster-buyer.service';


@Component({
  selector: 'distribution-number-component',
  templateUrl: 'distribution-number.component.html',
  styleUrls: ['./distribution-number.component.scss']
})
export class DistributionNumberComponent extends ItemDetailsComponent<DistributionNumber> implements OnInit, OnDestroy {

  @ViewChild('name', { read: ElementRef }) nameInput: any;
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;

  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  auctionClusterId: number;
  masterDataLookupSource: DataSource;
  buyerLookupSource = {};
  isFixedNumbers: boolean = false;

  constructor(
    protected injector: Injector,
    private dataService: DistributionManagementService,
    private masterDataService: MasterDataService,
    private buyerService: AuctionClusterBuyerService,
    private translateService: TranslateService
  ) {
    super(injector);
    this._subscription = this.language.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });

    this.buyerLookupSource = new DataSource({
      paginate: true,
      pageSize: 20,
      requireTotalCount: false,
      store: new CustomStore({
        key: 'buyerId',
        load: (loadOptions) => {
          if (loadOptions.searchValue) {
            loadOptions.filter = ["buyerDisplayValue", "contains", loadOptions.searchValue];
          }
          return this.buyerService.getBuyersForDropDownPaged(this.auctionClusterId, loadOptions).toPromise();
        },
        byKey: async (key) => {
          var result = await this.buyerService.getBuyerForDropDown(this.auctionClusterId, key).toPromise();
          return result;
        }
      }),

    });

    this.masterDataLookupSource = new DataSource({
      paginate: true,
      pageSize: 20,
      requireTotalCount: false,
      store: new CustomStore({
        key: 'masterDataListRowId',
        load: async (loadOptions) => {

          var result = await this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/,
            this.auctionClusterId, this.translateService.currentLang, null, loadOptions).toPromise();

            if(result.data.length == 1) {
              this.model.masterDataListRowId = result.data[0].value;
            }
            return result.data;
        },
        byKey: async (key) => {
          var result = await this.masterDataService.getSysMasterDataListForDropdown(15/*DistributionCategory*/,
            this.auctionClusterId, this.translateService.currentLang, key, null).toPromise();
          return result.data[0];
        }
      }),

    });


  }

  ngOnInit() {
    this.model = new DistributionNumber();
    this.initializeDayProperties();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  private initializeDayProperties() {
    this.model.mondayEnabled = false;
    this.model.tuesdayEnabled = false;
    this.model.wednesdayEnabled = false;
    this.model.thursdayEnabled = false;
    this.model.fridayEnabled = false;
    this.model.saturdayEnabled = false;
    this.model.sundayEnabled = false;
    this.model.monday = 0;
    this.model.tuesday = 0;
    this.model.wednesday = 0;
    this.model.thursday = 0;
    this.model.friday = 0;
    this.model.saturday = 0;
    this.model.sunday = 0;
  }

  onDayEnabledChanged() {
    // This method is called when any day enabled checkbox is toggled
    // The form will automatically disable/enable the corresponding numeric input
  }

  open(distributionNumberId: number, auctionClusterId: number, isFixedNumbers: boolean = false) {
    this.auctionClusterId = auctionClusterId;
    this.isFixedNumbers = isFixedNumbers;

    if (distributionNumberId != null) {
      this.isEditMode = true;
      this.spinner.show();
      this.dataService.getDistributionNumber(this.auctionClusterId, distributionNumberId)
        .subscribe((res: DistributionNumber) => {
          this.model = res;
          this.isOpened = true;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
            this.spinner.hide();
          });
    } else {
      this.model = new DistributionNumber();
      this.initializeDayProperties();
      this.isEditMode = false;
      this.isOpened = true;
      this.masterDataLookupSource.load();
    }
  }

  save() {
    this.model.auctionClusterId = this.auctionClusterId;
    if (this.isEditMode) {
      this.spinner.show();
      this.dataService.editDistributionNumber(this.auctionClusterId, this.model)
        .subscribe((res: any) => {
          this.model = new DistributionNumber();
          this.close(true);
          this.errorMessage = null;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
            this.spinner.hide();
          });
    } else {
      this.spinner.show();
      this.dataService.saveDistributionNumber(this.auctionClusterId, this.model)
        .subscribe((res: any) => {
          this.model = new DistributionNumber();
          this.close(true);
          this.errorMessage = null;
          this.spinner.hide();
        },
          error => {
            this.errorService.show(error);
            this.spinner.hide();
          });
    }
  }

  generateNumber()
  {
    this.dataService.getDistributionNumberSuggestion(this.auctionClusterId, this.model.masterDataListRowId)
      .subscribe((res: any) => {
        this.model.value = res.value;
      },
        error => {
          this.errorService.show(error);
        });
  }

  onFieldDataChanged(e: any) {
    if (e.component._isReady && e.component.NAME !== 'dxPopup') {
      const result = e.component.validate();
      if (result.brokenRules.length >= 1) {
        document.getElementsByName('btnDistributionNumberSubmit')[0].setAttribute('disabled', 'disabled');
      } else {
        document.getElementsByName('btnDistributionNumberSubmit')[0].removeAttribute('disabled');
      }
    } else {
      if (this.isEditMode) {
        document.getElementsByName('btnDistributionNumberSubmit')[0].removeAttribute('disabled');
      }
    }
  }

  get isGenerateDisabled(): boolean {
    return !this.model?.buyerId || !this.model?.masterDataListRowId;
  }
}
